import { createBrowserRouter } from "react-router-dom";
import LoginLayout from "./layouts/LoginLayout";
import LoginPage from "./pages/Login/LoginPage";
import MainLayout from "./layouts/MainLayout";
import ForgotPasswordPage from "./pages/Login/ForgotPasswordPage";
import ResetPasswordPage from "./pages/Login/ResetPasswordPage";
import EmailApprovePage from "./pages/Approvals/EmailApprovePage";
import ProtectedRoute from "./components/ProtectedRoute";

export const AppRoutes = createBrowserRouter([
  {
    // Everything below requires an authenticated session.
    element: <ProtectedRoute />,
    children: [
      {
        // MainLayout owns all authenticated routes; the tab workspace resolves
        // the actual page for the current URL (see tabs/tabRoutes.tsx).
        path: "*",
        element: <MainLayout />,
      },
    ],
  },
  {
    element: <LoginLayout />,
    children: [
      {
        path: "/forgot-password",
        element: <ForgotPasswordPage />,
      },
      {
        path: "/login",
        element: <LoginPage />,
      },
      {
        path: "/reset-password/:token",
        element: <ResetPasswordPage />,
      },
      {
        // One-click approval from a notification email. Public on purpose: the
        // token is the credential, and requiring a login here would defeat the
        // whole point of the button. See pages/Approvals/EmailApprovePage.tsx.
        path: "/approve/:token",
        element: <EmailApprovePage />,
      },
    ],
  },
]);
